<template>
  <AvatarRoot
    class="inline-flex select-none items-center justify-center overflow-hidden align-middle"
    :class="cn(avatar({ size, rounded }), props.class ? props.class : '')"
  >
    <AvatarImage
      v-show="!showFallback"
      class="size-full rounded-[inherit] object-cover"
      :src="src"
      :alt="alt"
      @loading-status-change="onLoadingStatusChange"
    />
    <span
      v-show="showFallback"
      :class="
        cn(
          'text-neutral-200 leading-1 flex size-full items-center justify-center bg-[#364345] font-semibold',
          props.size === 'large' ? 'text-base' : 'text-[0.675rem]'
        )
      "
      :style="{
        backgroundColor: color,
      }"
    >
      {{ initials.toUpperCase() }}
    </span>
  </AvatarRoot>
</template>

<script setup>
import { AvatarImage, AvatarRoot } from 'radix-vue';
import { cva } from 'class-variance-authority';
import { computed, ref } from 'vue';
import { cn } from '../../utils.js';

const props = defineProps({
  size: {
    type: String,
    default: 'medium',
  },
  rounded: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String,
    default: '',
  },
  src: {
    type: String,
    default: '',
  },
  alt: {
    type: String,
    default: '',
  },
  initials: {
    type: String,
    default: '',
  },
  class: {
    type: String,
    default: '',
  },
});

const avatar = cva('avatar', {
  variants: {
    size: {
      small: 'size-6',
      medium: 'size-7',
      large: 'size-12',
    },
    rounded: {
      true: 'rounded-full',
      false: 'rounded',
    },
  },
  compoundVariants: [{ size: 'medium' }],
});

const loadingStatus = ref('idle');

function onLoadingStatusChange(status) {
  loadingStatus.value = status;
}

const showFallback = computed(
  () => !props.src || loadingStatus.value === 'error'
);
</script>
